import { combineReducers } from 'redux';

const defaultSelectedObi = null;
const selectedObi = (state = defaultSelectedObi, action) => {
  switch (action.type) {
    case 'BOX_DETAILS_SELECT_OBI':
      return action.obi;
    case 'BOX_DETAILS_CLEAR_OBI_SELECT':
    case 'EPIK_BOX_OBIS_SUCCESS':
      return null;
    default:
      return state;
  }
};

const selectedPort = (state = defaultSelectedObi, action) => {
  switch (action.type) {
    case 'BOX_DETAILS_SELECT_PORT':
      return action.port;
    case 'BOX_DETAILS_CLEAR_PORT_SELECT':
    case 'EPIK_BOX_OBIS_SUCCESS':
      return null;
    default:
      return state;
  }
};

const defaultSelectedAta = null;
const selectAta = (state = defaultSelectedAta, action) => {
  switch (action.type) {
    case 'BOX_DETAILS_SELECT_ATA_PORT':
      return action.ata;
    case 'BOX_DETAILS_CLEAR_PORT_ATA_SELECT':
    case 'EPIK_BOX_OBIS_ATA_SUCCESS':
      return null;
    default:
      return state;
  }
};

const defaultShowUnassignedObi = false;
const showUnassignedObi = (state = defaultShowUnassignedObi, action) => {
  switch (action.type) {
    case 'UNASSIGNED_OBI_SHOW':
      return true;
    case 'UNASSIGNED_OBI_HIDE':
    case 'ASSIGN_OBI_TO_BOX':
    case 'BOX_CONFIG_SHOW':
      return false;
    default:
      return state;
  }
};

const defaultShowBoxConfig = false;
const showBoxConfigModal = (state = defaultShowBoxConfig, action) => {
  switch (action.type) {
    case 'BOX_CONFIG_SHOW':
      return true;
    case 'BOX_CONFIG_HIDE':
    case 'UNASSIGNED_OBI_SHOW':
      return false;
    default:
      return state;
  }
};

const defaultRearrangeEPIs = false;
const rearrangeEPIs = (state = defaultRearrangeEPIs, action) => {
  switch (action.type) {
    case 'SET_REARRANGE_EPI':
      return true;
    case 'CANCEL_REARRANGE_EPI':
    case 'UPDATE_BOX_EPIS_SUCCESS':
      return false;
    default:
      return state;
  }
};

const defaultRearrangedEPIs = [];
const rearrangedEpis = (state = defaultRearrangedEPIs, action) => {
  switch (action.type) {
    case 'SET_REARRANGE_EPI':
      return action.epis || [];
    case 'CANCEL_REARRANGE_EPI':
    case 'REARRANGE_EPI_SUCCESS':
      return [];
    default:
      return state;
  }
};

const defaultImportObj = {};
const importObj = (state = defaultImportObj, action) => {
  switch (action.type) {
    case 'IMPORT_EPIK_BOX_SUCCESS':
      return action.box;
    case 'CREATE_BOX_CANCEL':
      return defaultImportObj;
    default:
      return state;
  }
};

export default combineReducers({
  selectedObi,
  selectedPort,
  showUnassignedObi,
  showBoxConfigModal,
  rearrangeEPIs,
  rearrangedEpis,
  importObj,
  selectAta,
});
